import {  status,profileConstants ,editProfileConstants} from '../Constants';

export function profileUsers(state = {}, action: any) {
    switch (action.type) {
        case profileConstants.SEARCH_PROFILE_REQUEST:
            return {
                ...state,
                search_profile_status: status.IN_PROGRESS,
                searchProfileList: action.data
            };
        case profileConstants.SEARCH_PROFILE_SUCCESS:
            return {
                ...state,
                search_profile_status: status.SUCCESS,
                searchProfileList: action.data
            };
        case profileConstants.SEARCH_PROFILE_FAILURE:
            return {
                ...state,
                search_profile_status: status.FAILURE,
                searchProfileList: null
            };
        default:
            return state;
    }
}


export function editProfileUsers(state = {}, action: any) {
    switch (action.type) {
        case editProfileConstants.EDIT_PROFILE_REQUEST:
            return {
                ...state,
                edit_profile_status: status.IN_PROGRESS,
                editProfileList: action.data
            };
        case editProfileConstants.EDIT_PROFILE_SUCCESS:
            return {
                ...state,
                edit_profile_status: status.SUCCESS,
                editProfileList: action.data
            };
        case editProfileConstants.EDIT_PROFILE_FAILURE:
            return {
                ...state,
                edit_profile_status: status.FAILURE,
                editProfileList: null
            };
        default:
            return state;
    }
}